import { v4 as uuidv4 } from 'uuid';

export const obtenerIDLocal = () =>{

    let idLocal = window.localStorage.getItem('UID');
    if (idLocal) {
        return idLocal;
    }else{
        let deviceId = uuidv4(); // Genera un ID único como: "1b9d6bcd-bbfd-4b2d-9b5d-ab8dfbbd4bed"
        window.localStorage.setItem('UID', deviceId);
        return deviceId;
    }

}